import React, { FunctionComponent } from 'react';

import { AddAndRemove } from '../../../AddAndRemove';

import AttachmentItem from './AttachmentItem';
import { Attachment } from './AttachmentItem.types';

interface AttachmentsListProps {
  fileNames: Attachment[];
  onRemove?: (attachment: Attachment) => void;
  name?: string;
}

const AttachmentsList: FunctionComponent<
  React.PropsWithChildren<AttachmentsListProps>
> = ({ fileNames = [], onRemove, name }) => {
  return fileNames.map((item, index) => (
    <AddAndRemove key={index}>
      <AttachmentItem item={item} onRemove={onRemove} name={name} />
    </AddAndRemove>
  ));
};

export default AttachmentsList;
